// Google Consent Mode v2 helpers.
// The site ships a custom consent banner (src/components/site/CookieConsent.tsx).
// Defaults are DENIED until the visitor makes a choice; the choice is stored
// in localStorage and re-applied on every visit.

export const CONSENT_STORAGE_KEY = "avolus-consent-v1";

export type ConsentDecision = "granted" | "denied";

type Gtag = (...args: any[]) => void;

function pushGtag(...args: any[]) {
  if (typeof window === "undefined") return;
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  if (typeof w.gtag !== "function") {
    w.gtag = ((...a: any[]) => w.dataLayer.push(a)) as Gtag;
  }
  w.gtag(...args);
}

export function getStoredConsent(): ConsentDecision | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    return v === "granted" || v === "denied" ? v : null;
  } catch {
    return null;
  }
}

/** Must run before any gtag('config', ...) call. */
export function applyConsentDefaults() {
  pushGtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    wait_for_update: 500,
  });

  const stored = getStoredConsent();
  if (stored) pushGtag("consent", "update", consentPayload(stored));
}

function consentPayload(decision: ConsentDecision) {
  return {
    ad_storage: decision,
    ad_user_data: decision,
    ad_personalization: decision,
    analytics_storage: decision,
  };
}

export function setConsent(decision: ConsentDecision) {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, decision);
  } catch {
    /* storage unavailable - consent applies for this page view only */
  }
  pushGtag("consent", "update", consentPayload(decision));
}
